var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"organism-building-labels"},_vm._l((_vm.buildings),function(building,index){return _c('MoleculesProjectMoleculeBuildingLabel',{key:index,ref:"labelBuildingRef",refInFor:true,attrs:{"label-data":building}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }